var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoteNotifi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49955 4.16628H5.83303C5.39104 4.16628 4.96715 4.34186 4.65462 4.65439C4.34208 4.96693 4.1665 5.39082 4.1665 5.83281V15.832C4.1665 16.2739 4.34208 16.6978 4.65462 17.0104C4.96715 17.3229 5.39104 17.4985 5.83303 17.4985H14.1657C14.6076 17.4985 15.0315 17.3229 15.3441 17.0104C15.6566 16.6978 15.8322 16.2739 15.8322 15.832V5.83281C15.8322 5.39082 15.6566 4.96693 15.3441 4.65439C15.0315 4.34186 14.6076 4.16628 14.1657 4.16628H12.4991M7.49955 4.16628C7.49955 4.60827 7.67513 5.03216 7.98767 5.34469C8.3002 5.65723 8.72409 5.83281 9.16608 5.83281H10.8326C11.2746 5.83281 11.6985 5.65723 12.011 5.34469C12.3235 5.03216 12.4991 4.60827 12.4991 4.16628M7.49955 4.16628C7.49955 3.72429 7.67513 3.3004 7.98767 2.98787C8.3002 2.67534 8.72409 2.49976 9.16608 2.49976H10.8326C11.2746 2.49976 11.6985 2.67534 12.011 2.98787C12.3235 3.3004 12.4991 3.72429 12.4991 4.16628",
    stroke: "#6B7280",
    strokeWidth: 1.66652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteNotifi);
export default __webpack_public_path__ + "static/media/note-notifi.72659c8cb9336e6165d9ffc28533605b.svg";
export { ForwardRef as ReactComponent };